import React from 'react'
import HomePage from 'components/templates/navigationPageTemplates/HomePage'
import { Button, CardContent, Divider, Typography } from '@mui/material'
import { PageHeader } from 'components/atoms/Text'
import SinglePageStack from 'components/templates/SinglePageStack'
import StyledAccordion from 'components/atoms/container/Accordion'
import { useChannelIOApi } from 'react-channel-plugin'
import { useTranslation } from 'react-i18next'

const HelpAndSupport = () => {
  const { t } = useTranslation()
  const { showMessenger } = useChannelIOApi()

  return (
    <HomePage>
      <SinglePageStack spacing={10}>
        <PageHeader>{t('headers.helpSupport')}</PageHeader>
        <Typography variant='h4'>
          {t('support.frequentlyAskedQuestions')}
        </Typography>
        {Array.isArray(t('support.FAQ_LIST'))
          ? t('support.FAQ_LIST').map((item, index) => (
              <StyledAccordion
                initialExpanded={index === 0}
                key={index}
                summaryComponent={<>{item.question}</>}>
                <Typography variant='body1Small'>{item.answer}</Typography>
              </StyledAccordion>
            ))
          : null}
        <Divider />
        <PageHeader>{t('company.contactUs')}</PageHeader>
        <Typography variant='h4' style={{ marginTop: 5 }}>
          {t('support.haveQuestion')}
        </Typography>
        <CardContent>
          <Button onClick={() => showMessenger()}>
            {t('common.sendMessage')}
          </Button>
        </CardContent>
      </SinglePageStack>
    </HomePage>
  )
}

export default HelpAndSupport
